import * as React from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';

import './_tile.scss';

export type Props = {
    title: string;
    onClick: FlowAnyFunction;
    icon?: React.ReactNode;
    borderColor?: string;
    children?: React.ReactNode;
};

export const Tile = ({
    title,
    onClick,
    icon = undefined,
    borderColor = undefined,
    children = undefined,
}: Props): React.ReactElement => {
    const paperStyle = { boxShadow: '4px 8px 24px rgba(0, 0, 0, 0.06)' };

    if (borderColor) {
        const color = borderColor || '#003cac';
        const baseBoxShadow =
            '0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)';
        paperStyle.boxShadow = `${baseBoxShadow}, 0px 0px 0px 4px ${color} inset`;
    }

    return (
        <Paper
            style={paperStyle}
            className="dashboard-new-tile-paper"
            onClick={onClick}
            data-e2e={title}
            data-testid={title}
        >
            <div className="dashboard-tile-title">
                {icon || null}
                <Tooltip title={title}>
                    <Typography noWrap variant="body1Bold">
                        {title}
                    </Typography>
                </Tooltip>
            </div>
            {children}
        </Paper>
    );
};
